import Vue from "vue";
import Router from "vue-router";
// 引入组件
import Index from "../views/IndexView.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/index",
    },
    {
      path: "/index",
      name: "index",
      component: Index,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js